import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
const Layout = (props) => {
    return (  <>
    <Navbar homeCSS={props.children?.props?.homeCSS}/>
    {props.children}
    <Footer/>
    </>);
}
 
export default Layout;